import Interceptor from '@finx/web-repository/src/apis/Interceptor'
import Env from '@finx/web-repository/src/services/Env'

export default class IntegradorFinxInterceptor {
  api: any = new Interceptor()
  config: object = {
    baseURL: Env.API_INTEGRADOR_FINX,
  }

  delete(url: string): any {
    return this.api.delete(url, this.config)
  }

  get(url: string): any {
    return this.api.get(url, this.config)
  }

  post(url: string, data: any): any {
    return this.api.post(url, data, this.config)
  }

  put(url: string, data: any): any {
    return this.api.put(url, data, this.config)
  }
}
